import Modal from "../modal.component";
import OrderedPartForm from "../../forms/parts/orderPart/orderedPart.form";

const CreateOrderedPartModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex justify-evenly h-full w-full flex-row gap-6">
        <OrderedPartForm />
      </div>
    </Modal>
  );
};

export default CreateOrderedPartModal;
